module.exports = "/assets/delice-page/all@2x.jpg?ya2G2BX";